import React, { useState, useContext } from 'react';
import img from '../../src/assets/usr_bg2.jpg';
import tickImg from '../../src/assets/tick2.png';
const Login = () => {






    return (
        <>


            <div className="container-fluid">
                <div className="row mt-2 mb-4">
                    <div className="col-md-12">
                        <div className="card text-center">
                            <div className="card-header" style={{ backgroundImage: `url(${img})`, color: 'white', fontWeight: 'bold', fontSize: '18px' }}>
                                Thank You!
                            </div>
                            <div className="card-body">
                                <div className="card mx-auto" style={{ maxWidth: '500px' }}>
                                    <div className="card-body">
                                        <img src={tickImg} alt="Success" style={{ width: '50px', marginBottom: '20px' }} />
                                        <h5 className="card-title">Your payment was successful!</h5>
                                        <p className="card-text"><span style={{ color: '#2D3748', fontWeight: 'bold' }}>Transaction ID:</span> TXN20240319123456789</p>
                                        <p className="card-text"><span style={{ color: '#2D3748', fontWeight: 'bold' }}>Package Name:</span> Basick Pack</p>
                                        <p className="card-text"><span style={{ color: '#2D3748', fontWeight: 'bold' }}>Payment Email ID:</span> rashmiranjansahoo@gmail.com</p>
                                        <p className="card-text text-success" style={{ fontWeight: 'bold', fontSize: '20px' }}>Thank you for your purchase!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>








        </>
    );
};

export default Login;
